// extracted by mini-css-extract-plugin
export default {"container":"PalletAmountSection_container__rTzaR"};